<script setup>
import { ref, onUnmounted } from 'vue';
import AppConfig from '@/_freya_layout/freya_theme/AppConfig.vue';
import { useRouter } from 'vue-router';
import passwordService from '@/services/password.service'
import { pageSuccess, pageError }  from '@/modules/HttpResponse'

const router = useRouter();
const email = ref();
const isEmailSent = ref(false)
const isPageLoading = ref(false)

import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/yup';
import * as yup from 'yup';

const initialValues = {
  email: null,
}

const schema = toTypedSchema(
  yup.object({
    email: yup
      .string()      
      .email("Invalid email format")
      .required("Your email is required")
  })
)

const {
  handleSubmit,
  errors,
  setErrors,
  controlledValues,
  defineComponentBinds,
  setFieldValue,
} = useForm({
  validationSchema: schema,
  initialValues: initialValues,
});

const formInputs = ref({
  email: defineComponentBinds('email'),
})

const navigateToDashboard = () => {
  router.push('/');
};

const resetPassword = handleSubmit(values => {
  isPageLoading.value = true
  passwordService
    .create({ password: {email: values.email }})
    .then(response => {
      isEmailSent.value = true
      pageSuccess(response)
    })
    .finally(() => isPageLoading.value = false)
})

onUnmounted(() => isEmailSent.value = false)
</script>

<template lang="pug">

.card(v-if="isEmailSent")
  .text-green-700
    i.mr-4.text-3xl.font-bold.pi.pi-check-circle
    span.text-4xl.font-bold Email Sent
  .my-6.text-xl If your email is registered in our system, an email has been sent with a link to reset your password.
  div
    Button.w-full(v-ripple='' label='<< Back to login' @click='navigateToDashboard' outlined)

.card(v-else)
  .mb-4
    .text-900.text-xl.font-bold.mb-2 Forgot Password
    

  form.formgrid.grid.p-fluid(@submit.prevent="resetPassword")

    .field.col-12.mb-4
      label(for="email") Enter your email to reset your password
      IconField(iconPosition="left")
        InputIcon.pi.pi-envelope
        InputText#email.text-center(v-bind="formInputs.email" type="text" placeholder="Your Email Address")
      .mt-3.text-lg.text-red-600(v-if="errors.email") {{ errors.email }}  

    .field.col-12.mb-0
      .flex.flex-start.gap-3
        Button(v-ripple='' label='Cancel' @click='navigateToDashboard' outlined severity="secondary")
        Button(v-ripple='' type="submit" label='Submit' :loading="isPageLoading")
      
AppConfig(simple='')
</template>
